import { darken, type Theme } from '@mui/material/styles';

/** Dark-mode registry rail: very dark tint of the active theme primary */
export function registrySidebarDarkBackground(theme: Theme) {
  return darken(theme.palette.primary.main, 0.88);
}
